import { Row, Col } from 'antd';
import Barcode from 'react-barcode';
import PropTypes from 'prop-types';

export function LRBarCode({ value }) {
	return (
		<Row justify="center">
			<Col>
				<Barcode value={value} />
			</Col>
		</Row>
	);
}

LRBarCode.propTypes = {
	value: PropTypes.string,
};
